import { TextField, TextFieldProps } from '@mui/material';
import Required from 'components/commons/Required';
import Text from 'components/commons/Text';
import Row from 'components/layouts/Row';
import React, { CSSProperties, forwardRef, useRef, useImperativeHandle } from 'react';

interface InputFieldProps extends Omit<TextFieldProps, 'onChange'> {
  label?: string;
  style?: CSSProperties;
  required?: boolean;
  onChange?: (value: string) => void;
  defaultValue?: string;
}

const InputField = forwardRef(
  (
    { label, style, required, onChange, helperText, defaultValue, ...props }: InputFieldProps,
    ref: any,
  ) => {
    const titleRef = useRef<HTMLInputElement>(null);
    useImperativeHandle(ref, () => ({
      focus,
    }));

    const focus = () => {
      titleRef.current?.focus();
    };

    return (
      <div style={{ width: '100%', ...style }}>
        <Row style={{ justifyContent: 'flex-start', marginBottom: 5 }}>
          <Text type="H4">{label}</Text>
          <>{required && <Required />}</>
        </Row>
        <TextField
          key={defaultValue}
          inputRef={titleRef}
          fullWidth
          defaultValue={defaultValue}
          helperText={helperText}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            onChange?.(e.target.value);
          }}
          {...props}
        />
      </div>
    );
  },
);

export default InputField;
